<template>
  <div class="greetcard-box">
    <div class="tool-box">
      <div class="tool-btn" @click="handleSpin">切换皮肤</div>
      <ul class="tool-list" v-show="showTool">
        <li class="tool-item" v-for="(item, index) in toolList" :key="index" @click="handleChange(item)">
          <img :src="item.imgUrl" alt="">
        </li>
      </ul>
    </div>
    <div>
      <button class="share-btn" @click="handleShare">分享</button>
    </div>
    <div class="content-box">
      <img class="bg-img" :src="imgCanvas" alt="">
      <div class="edit-box">
        <img :src="editbg" alt="" />
        <div class="edit-content">
          <textarea ref="inputBox" class="input-box" :style="{ color: curColor }" v-model="inputValue" name="" id="" cols="30" rows="5" placeholder="请留下您对老师的祝福~
（请勿输入空格和换行）" maxlength="70" @blur="handleBlur"></textarea>
          <div class="color-box">
            <span class="color-first" :style="{ color: '#7A7A7A' }" @click="handleColor('#282828')">A</span>
            <span class="color-item" :style="{ background: item }"  v-for="(item, index) in colorList" :key="index" @click="handleColor(item)"></span>
          </div>
        </div>
      </div>
    </div>
    <div ref="imgbox" id="imgbox" class="content-box img-box">
      <img class="bg-img" :src="imgCanvas" alt="" />
      <div class="edit-box">
        <img :src="editbg" alt="" />
        <div class="edit-content">
          <div class="input-text" :class="[ isIndent ? 'input-indent' : '']" :style="{ color: curColor }" v-html="shareValue"></div>
        </div>
      </div>
    </div>
    <share-sheet :showShare="showShare" @share="handleShareContent" @cancleShare="handleCancelShare"></share-sheet>
    <div v-if="loading" class="share-loading">
      <span>分享中...</span>
    </div>
  </div>
</template>
<script>
import html2canvas from 'html2canvas'
import { uploadImg } from '@/api/teacherCard'
import { setStore, getDevice } from '@/utils/index'
import shareSheet from '@/components/shareSheet'
export default {
  components: {
    shareSheet
  },
  data () {
    return {
      isIndent: false,
      loading: false,
      editbg: require('../../assets/images/teacherCard/inputbg1.png'),
      shareValue: '',
      inputValue: '',
      showShare: false,
      showTool: false,
      curColor: '#282828',
      type: 0,
      colorList: [
        '#000', '#666565', '#FF0000', '#FC9005', '#2E6BFD', '#16B701'
      ],
      toolList: [
        {
          imgUrl: require('../../assets/images/teacherCard/btn1.png'),
          bgUrl: require('../../assets/images/teacherCard/bg1.png'),
          editbg: require('../../assets/images/teacherCard/inputbg1.png'),
          canvasUrl: require('../../assets/images/teacherCard/bgimg1.png')
        },
        {
          imgUrl: require('../../assets/images/teacherCard/btn2.png'),
          bgUrl: require('../../assets/images/teacherCard/bg2.png'),
          editbg: require('../../assets/images/teacherCard/inputbg2.png'),
          canvasUrl: require('../../assets/images/teacherCard/bgimg2.png')
        },
        {
          imgUrl: require('../../assets/images/teacherCard/btn3.png'),
          bgUrl: require('../../assets/images/teacherCard/bg3.png'),
          editbg: require('../../assets/images/teacherCard/inputbg3.png'),
          canvasUrl: require('../../assets/images/teacherCard/bgimg3.png')
        }
      ],
      imgbg: require('../../assets/images/teacherCard/bg1.png'),
      imgCanvas: require('../../assets/images/teacherCard/bgimg1.png'),
      url: ''
    }
  },
  created () {
    const token = this.$route.query.token
    if (token) {
      setStore('token', token)
    }
    this.getDevice()
  },
  methods: {
    getDevice () {
      const device = getDevice()
      if (device === 'ios') {
        this.isIndent = true
      } else {
        this.isIndent = false
      }
    },
    // 切换字体颜色
    handleColor (item) {
      this.curColor = item || '#282828'
    },
    handleBlur () {
      if (this.inputValue) {
        this.shareValue = this.inputValue.replace(/[\n\r]/g, '<br/>')
      }
    },
    handleShare () {
      this.showShare = true
    },
    handleCancelShare () {
      this.showShare = false
    },
    handleShareContent (type) {
      this.type = type
      this.createImg()
    },
    // 切换模板
    handleSpin () {
      this.showTool = !this.showTool
    },
    handleChange (item) {
      this.imgbg = item.bgUrl
      this.imgCanvas = item.canvasUrl
      this.editbg = item.editbg
      this.shareValue = ''
      this.inputValue = ''
    },
    // 生成图片
    createImg () {
      const el = document.getElementById('imgbox')
      var opts = {
        x: 0,
        y: 0,
        background: 'transparent',
        scrollY: 0,
        useCORS: true,
        logging: true
      }
      html2canvas(el, opts).then((canvas) => {
        this.url = canvas.toDataURL('image/png')
        this.handleUpload(this.url)
      })
    },
    handleUpload (url) {
      this.loading = true
      const requestData = {
        activityId: 2001,
        pictureBase64: this.filterImg(url),
        picId: 1
      }
      uploadImg(requestData).then((res) => {
        console.log(res)
        const data = res.data
        if (data.result) {
          const shareUrl = data.result
          console.log(shareUrl)
          this.getShare(shareUrl)
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    filterImg (imgbase) {
      return imgbase.replace('data:image/png;base64,', '')
    },
    getShare (shareUrl) {
      dsBridge.call('callShareWithType', {
        thirdType: this.type,
        contentShareType: 2,
        title: '见字如面 诗情画意赠恩师',
        content: '期待着您来写下不一样的“老师，我想对您说”',
        image: '',
        urlStr: shareUrl
      }, function () {})
      this.showShare = false
    }
  }
}
</script>
<style scoped lang="scss">
.greetcard-box {
  position: relative;
  height: 100vh;
  // overflow: hidden;
}
.share-loading {
  position: absolute;
  bottom: 60px;
  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 10000;
  span {
    display: inline-block;
    background: rgba(0, 0, 0, 0.7);
    color: #fff;
    border-radius: 5px;
    padding: 3px 6px;
    font-size: 12px;
  }
}
.share-btn {
  position: fixed;
  top: 6%;
  right: 15px;
  background: #ec5843;
  font-size: 14px;
  border-radius: 5px;
  padding: 0 5px;
  border-radius: 50%;
  color: #fff;
  width: 40px;
  height: 40px;
  line-height: 40px;
  z-index: 1;
}
.content-box {
  display: flex;
  flex-direction: column;
  position: relative;
  box-sizing: border-box;
  height: 100vh;
  overflow-x: hidden;
  overflow: hidden;
}
.bg-img {
  width: 100%;
  height: 100%;
}
.edit-box {
  box-sizing: border-box;
  position: absolute;
  bottom: 11%;
  width: 84vw;
  height: 50vw;
  margin: 0 8vw;
  border: none;
  outline: none;
  resize: none;
  border-radius: 10px;
  font-size: 14px;
  z-index: 1;
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: left top;
  background-size: 100%;
  img {
    width: 100%;
    height: 100%;
  }
}
.edit-content {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 6%;
}
.input-box {
  display: block;
  width: 75%;
  margin: 6% 8%;
  resize: none;
  border: none;
  outline: none;
  background: #FFFBF4;
  font-size: 14px;
}
.input-text {
  display: block;
  width: 75%;
  margin: 15px auto 8px;
  text-align: left;
  word-break: break-all;
  word-wrap: break-word;
  background: #FFFBF4;
  font-size: 14px;
  min-height: 70px;
}
.input-indent {
  text-indent: 1em;
  position: relative;
  left: -1.2em;
}
.color-box {
  box-sizing: border-box;
  position: absolute;
  bottom: 15px;
  left: 5.5%;
  width: 85%;
  padding: 8px 10px 12px 5px;
  border-top: 1px solid #E2E2E2;
  display: flex;
  align-items: center;
  justify-content: center;
}
.color-first{
  margin-right: 8px;
}
.color-item {
  width: 14px;
  height: 14px;
  background: #ddd;
  margin: 0 8px;
  border-radius: 50%;
}
.img-box {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100vh;
  background-repeat: no-repeat;
  background-position: left top;
  background-size: 100%;
  z-index: -1;
}
.text-box {
  box-sizing: border-box;
  position: absolute;
  bottom: 3%;
  width: 90%;
  margin: 0 5%;
  font-size: 14px;
  height: 110px;
  background: #fff;
  border-radius: 5px;
  padding: 15px;
}
.tool-btn {
  position: fixed;
  top: 6%;
  left: 0;
  z-index: 10;
  padding: 6px 10px;
  font-size: 12px;
  background: #d55857;
  border-radius: 0 30px 30px 0;
  box-shadow: 3px 3px 3px 0px #af3b3a;
  color: #fff;
  font-size: 15px;
  white-space: nowrap;
}
.tool-list {
  position: fixed;
  top: 14%;
  left: 10px;
  z-index: 1;
}
.tool-item {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  margin-bottom: 12px;
  background: #fff;
  border-radius: 50%;
  img {
    width: 100%;
  }
}
.create-box {
  background: #ddd;
  height: 100vh;
  img {
    width: 100%;
  }
}
</style>
